enum UnderwriterOwner {
  TAF_MRA = 'TAF_MRA',
  IPT_MAGNUM = 'IPT_MAGNUM',
  QL_REFLEX = 'QL_REFLEX',
  ZEL_AURA = 'ZEL_AURA',
}

export default UnderwriterOwner;
